import { motion } from "framer-motion";
import ImageFrame from "@/components/site/ImageFrame";

export function PageHeader({ eyebrow, title, lead, label = "BORGO PHOTO", alt = "", src }) {
  return (
    <section className="relative bg-wood-deep grain pt-36 pb-20 md:pt-44 md:pb-28 overflow-hidden">
      <div className="absolute inset-0 opacity-55">
        <ImageFrame src={src} label={label} alt={alt} ratio="auto" dark priority className="h-full w-full" />
        <span className="absolute inset-0 bg-gradient-to-t from-wood-deep via-wood-deep/75 to-wood-deep/45" />
      </div>
      <div className="container-ed relative z-10">
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <div className="flex items-center gap-4">
            <span className="rule" aria-hidden="true" />
            <p className="eyebrow text-gold">{eyebrow}</p>
          </div>
          <h1 className="mt-6 max-w-[24ch] font-serif text-[2.4rem] sm:text-5xl lg:text-[4.2rem] leading-[1.04] tracking-tight text-cream">
            {title}
          </h1>
          {lead && <p className="mt-7 max-w-xl text-sm md:text-lg text-cream/70 leading-relaxed">{lead}</p>}
        </motion.div>
      </div>
    </section>
  );
}

export default PageHeader;
